import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@ann/web-components";

const ArchiveModal = ({ isOpen, onClose, onArchive, triggerName }) => {
  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      closeFromOutside={true}
    >
      <Modal.Header icon>
        <Modal.Header.Title>Archive Trigger?</Modal.Header.Title>
        <Modal.Header.Description>          
          Are you sure you want to archive {triggerName}?
        </Modal.Header.Description>
        <Modal.Header.Description>
          You can restore it from your archive at any time.{" "}
        </Modal.Header.Description>
      </Modal.Header>
      <Modal.Body></Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button label="Cancel" onClick={onClose} type="secondary" />
        <Modal.Button
          label="Archive"
          onClick={() => {
            onArchive();
            onClose();
          }}
          type="warning"
        />
      </Modal.Actions>
    </Modal>
  );
};

ArchiveModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onArchive: PropTypes.func.isRequired,
  triggerName: PropTypes.string,
};

export default ArchiveModal;
